import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-void">
        <div className="w-12 h-12 border-2 border-glow-primary border-t-transparent rounded-full animate-spin shadow-[0_0_20px_rgba(0,240,255,0.4)]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
